module.exports = __webpack_public_path__ + "static/media/Groupcategory.93e20ab7.svg";